import { render, staticRenderFns } from "./warehousing.vue?vue&type=template&id=bd1ad844&scoped=true"
import script from "./warehousing.vue?vue&type=script&lang=js"
export * from "./warehousing.vue?vue&type=script&lang=js"
import style0 from "./warehousing.vue?vue&type=style&index=0&id=bd1ad844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1ad844",
  null
  
)

export default component.exports